import { Component, OnInit } from '@angular/core';
import { BasePage } from 'src/app/lib/base-page';

@Component({
  selector: 'app-service-support',
  templateUrl: './service-support.page.html',
  styleUrls: ['./service-support.page.scss'],
})
export class ServiceSupportPage extends BasePage implements OnInit {


  constructor() {
    super()
  }

  ngOnInit() {
  }

}
